module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4308/img/cms-free-signup.png"